import {uuid} from "@/interfaces";
import {PropertyUserMetadata} from "@/models/properties.model.ts";
import {PropertyUsersRepository} from "@/repositories/property-users.repository.ts";
import {PropertyUserDisplayModel} from "./property-users.entity";

export async function searchPropertyUsers(propertyId: uuid): Promise<PropertyUserDisplayModel[]> {
    return PropertyUsersRepository.listByProperty(propertyId);
}

export async function createPropertyUser(propertyId: uuid, userId: uuid, metaData: PropertyUserMetadata, isPrimaryContact: boolean): Promise<void> {
    return PropertyUsersRepository.addUser(propertyId, userId, metaData, isPrimaryContact);
}

export async function createPropertyContact(propertyId: uuid, email: string, metaData: PropertyUserMetadata, isPrimaryContact: boolean): Promise<void> {
    return PropertyUsersRepository.addContact(propertyId, email, metaData, isPrimaryContact);
}

export async function patchPropertyUser(propertyId: uuid, id: uuid, metaData: PropertyUserMetadata, isPrimaryContact: boolean): Promise<void> {
    return PropertyUsersRepository.updateMeta(propertyId, id, metaData, isPrimaryContact);
}

export async function deletePropertyUser(propertyId: uuid, id: uuid): Promise<void> {
    return PropertyUsersRepository.removeUser(propertyId, id);
}
